import { MAX_SIZE_IN_MEGAPIXELS } from './constants';
import { getImageSizeInMegapixels } from './helpers';
export const getDimensionsErrorMessage = (expectedDimensions, imageDimensions) => {
    const { minWidth, maxWidth, minHeight, maxHeight } = expectedDimensions;
    const { width, height } = imageDimensions;
    const sizeInMegaPixels = getImageSizeInMegapixels(width, height);
    if (sizeInMegaPixels > MAX_SIZE_IN_MEGAPIXELS)
        return `Invalid file dimensions (${width}x${height}). File dimensions must be less than ${MAX_SIZE_IN_MEGAPIXELS} megapixels (width x height)`;
    return `Invalid file dimensions (${width}x${height}). File dimensions must be between ${minWidth}x${minHeight} and ${maxWidth}x${maxHeight}`;
};
export const getSizeErrorMessage = (expectedSize, fileSizeInMB) => {
    return `Invalid file size (${fileSizeInMB} MB). File size must be less than ${expectedSize} MB`;
};
export const getFormatErrorMessage = (expectedFormats, fileFormat) => {
    return `Invalid file format (${fileFormat}). File format must be ${expectedFormats
        .map((format) => format)
        .join(', ')}`;
};
//# sourceMappingURL=error-messages.js.map